import BtnOptions from './BtnOptions';
import SelectParentPlantGroupFolder from '../../../../components/form/Selects/SelectParentPlantGroupFolder';

const Report56Options = ({
  handleOnSetFieldValue,
  handleOnSubmit,
  handleOnSave,
  values,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <SelectParentPlantGroupFolder
            onHandleChange={(opt) => {
              handleOnSetFieldValue('parentPlantGroupFolder', opt);
            }}
            value={values?.parentPlantGroupFolder}
            hasSearchBox
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={!values.parentPlantGroupFolder}
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
};

export default Report56Options;
